import { ServiceRequest } from "../utils/service-request"
import {MOTOR_CADASTRO_PATH} from "../utils/api-routes"

class MotorJurosService {
    constructor() {
        this.request = new ServiceRequest()
    }

    async getCadastroJuros() {
        const path = `${MOTOR_CADASTRO_PATH}/juros`
        return this.request.get(path)
    }
}

export default MotorJurosService